import { GlobeIcon } from "@phosphor-icons/react/Globe";
import type { ReactNode } from "react";
import type { CustomsDocsDropzoneProps } from "@/Shared/CustomDocs/CustomComponents/CustomDocsDropzone";
import { CustomDocsDropzone } from "@/Shared/CustomDocs/CustomComponents/CustomDocsDropzone";

interface CustomsDocsSubmitSectionProps extends CustomsDocsDropzoneProps {
  title?: ReactNode | undefined;
  subtitle?: ReactNode | undefined;
}

export function CustomDocsSubmitSection({
  title,
  subtitle,
  ...props
}: CustomsDocsSubmitSectionProps) {
  return (
    <div className="flex w-full flex-col items-center">
      <GlobeIcon
        className="h-12 w-12"
        weight="fill"
        style={{
          color: "var(--color-blue)",
          marginBottom: "16px",
          marginTop: "16px",
        }}
      />
      <div className="text-[30px] font-semibold text-foreground">{title}</div>
      <div className="text-center text-[18px] font-light text-content-muted [&_strong]:text-foreground">
        {subtitle}
      </div>
      <div className="h-[32px]" />
      {/* The dropzone fills its parent, so the section sets the width: the
          same 480px it always had on desktop, narrower on a phone. */}
      <div className="w-full max-w-[480px]">
        <CustomDocsDropzone {...props} />
      </div>
      <div className="h-[32px]" />
    </div>
  );
}
